// Lazy-load this FileViewer, since it uses Framer Motion and includes a bunch of stuff.
'use client';

import dynamic from 'next/dynamic';

const FileViewer = dynamic(() => import('./FileViewer'));

export default FileViewer;
